var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWww = function SvgWww(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#E3F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#www_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3B7CC9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M19.667 12A6.667 6.667 0 0 1 13 18.667M19.667 12A6.667 6.667 0 0 0 13 5.333M19.667 12H6.333M13 18.667A6.667 6.667 0 0 1 6.333 12M13 18.667a9.667 9.667 0 0 1 0-13.334m0 13.334a9.667 9.667 0 0 0 0-13.334M6.333 12A6.667 6.667 0 0 1 13 5.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "www_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 4h16v16H5z"
  })))));
};
export default SvgWww;